import Vue from "vue";
import { SurveyForm } from "@/models/SurveyForm";

class Store<S extends State> {
  private instance: Vue;

  constructor(initialState: State) {
    this.instance = new Vue({
      data: Object.assign({}, initialState)
    });
  }

  get state(): S {
    return (this.instance.$data as never) as S;
  }

  public static readonly __SurveyForm__ = "__SurveyForm__";

  setSurveyForm(surveyForm: SurveyForm) {
    localStorage.setItem(Store.__SurveyForm__, JSON.stringify(surveyForm));
    this.instance.$data.surveyForm.title = surveyForm.title;
    this.instance.$data.surveyForm.details = surveyForm.details;
    this.instance.$data.surveyForm.surveyItems = surveyForm.surveyItems;
  }
}

export interface State {
  surveyForm: SurveyForm;
}

export class AppStore extends Store<State> {}
